import { LocationQueryRaw } from "vue-router";

import type { MeVo } from "@supplier/entity";

import * as loginService from "@/api/loginService";
import { UserInfo, useUserStore } from "@/stores/user";
import { useAccountStore } from "@/stores/account";
import { useTabsStore } from "@/stores/tabs";
import { getCustomerRealMobileById, getCustomerRealNameById } from "@/api/customerService";
import router from "@/routers";
import { fileService } from "@/api/fileService";
import Tenant from "@/function/tenant";
import { getEnterpriseMainBodyByCustomerId } from "@/api/mainBodyService";

/**获取用户信息 */
export const getUserInfo = async () => {
    const data = await loginService.getMe();
    data.actualAccount.realName = await getCustomerRealNameById(data.actualAccount.id);
    data.actualAccount.mobile = await getCustomerRealMobileById(data.actualAccount.id);
    const customerVo = {
        customer: data.actualAccount,
        systemType: data.systemType,
        permissions: data.permissions,
        memberPermission: data.actualMemberPermission,
        proxyAccount: data.proxyAccount,
        proxyMemberPermission: data.proxyMemberPermission,
        mainBody: data.mainBody
    } as UserInfo & Pick<MeVo, "proxyMemberPermission">;
    const userStore = useUserStore();
    userStore.setNeedRefreshUserInfo(false);
    userStore.setMobile(data.actualAccount.mobile);
    userStore.setUserInfo(customerVo);
    userStore.setBindTime(data.bindTime);
    userStore.setNickName(data.nickName);
    userStore.setAuthorizationState(data.authorizationState);
    userStore.setPasswordUpdateTime(data.actualAccount.passwordUpdateTime);
    const accountStore = useAccountStore();
    // if (!accountStore.accountType === AccountType.ROOT_ACCOUNT) {
    accountStore.setMainBody(data.mainBody);
    // }
    accountStore.setAccountType();
    accountStore.setActualAccount(customerVo.customer);
    accountStore.setProxyAccount(customerVo.proxyAccount);
    accountStore.setProxyMemberPermission(customerVo.proxyMemberPermission);
    if (!accountStore?.mainBody?.id) {
        const mainBody = await getEnterpriseMainBodyByCustomerId(customerVo.customer.id);
        accountStore.setMainBody(mainBody);
    }
    await setSystemLogo(data);
    return;
};

// 设置系统logo
const setSystemLogo = async (data: MeVo) => {
    const userStore = useUserStore();
    const accountStore = useAccountStore();
    // 当前切换非主账号则获取proxyAccount
    const currentAccount = accountStore.isRootAccount ? data.actualAccount : data.proxyAccount;
    const systemLogoFileId = currentAccount.systemLogo;
    const systemName = currentAccount.systemName;
    userStore.setSystemName(systemName);
    if (systemLogoFileId) {
        const { path } = await fileService.getFileById(systemLogoFileId);
        if (path) {
            userStore.setSystemLogo(path);
        }
    } else {
        userStore.setSystemLogo(null);
    }
    await Tenant.getInstance().init();
};
// 返回上个页面，支持新开页面
export const goBackToFromWindow = (fromPageName?: string, query?: LocationQueryRaw) => {
    // 历史记录中只有一条数据，且新开的窗口
    if (window.opener && !history.state.back) {
        window.opener.focus();
        if (fromPageName) {
            // 返回原页面，如果原页面变了，则跳转fromPageName对应的地址
            const fromUrl = fromPageName ? router.resolve({ name: fromPageName }).href : undefined;
            const originUrl = window.opener.location.href;
            if (originUrl !== window.location.origin + fromUrl) {
                window.opener.location.href = fromUrl;
            }
        }
        window.close(); // 关闭当前页面
    } else if (fromPageName) {
        router.push({ name: fromPageName, query: (query as LocationQueryRaw) || {} }).then(); // 跳转到指定页面，并传递查询参数
    } else {
        // 如果没有上个页面，且当前页面的tab页签已经关闭，页面还停留在原地，则在tab页签中添加上当前路由
        if (!history.state.back) {
            const route = router.currentRoute.value;
            const tabStore = useTabsStore();
            if (!tabStore.tabsMenuList.some(item => item.name === route.name)) {
                tabStore
                    .addTabs({
                        name: route.name as string,
                        title: route.meta.title as string,
                        icon: route.meta.icon as string,
                        path: route.fullPath,
                        close: !route.meta.isAffix
                    })
                    .then();
            }
        } else {
            router.go(-1);
        }
    }
};

// 四舍五入 decimal 保留的小数位数
export const roundOff = (num: number, decimal: number = 0) => {
    if (!num) {
        return num;
    }
    const pow = 10 ** decimal;
    let res = Math.round(num * pow) / pow;
    res = +res.toFixed(decimal);
    return res;
};
